import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { UserService } from '../../services/user.service';
import { SweetAlertService } from '../../services/sweet-alert.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuard  implements CanActivate{
  constructor(
      private _user: UserService,
      private _alert : AlertService,
      private router: Router,
      private _sweetAlert:SweetAlertService
    ){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this._user.getUser()){
        if(this._user.getUser().actor === 'microempresario'){
          return true;
        }
      }else{
        this._sweetAlert.infoModal("Error!",true,'No se encuentra logueado en el sistema');
        this.router.navigateByUrl('/microempresario/login');
        return false;
      }
  }
}
